import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context/AppContext';
import styles from './SearchBarLocationInput.module.scss';
import ISearch from '../../../interfaces/ISearch';
import { defaultAppState } from '../../../context/DefaultAppState';
import { checkValidZip, evaluateIsDisabled } from '../../../lib/util';

const SearchBarLocationInput = (props: any) => {
  const { location, updateLocation, distance, updateIsDisabled, search, updateSearch } = useContext(AppContext);
  
  const [ buttonClassName, setButtonClassName ] = useState<string>(``);
  //const [ required, setRequired ] = useState<boolean>(true);

  useEffect(() => {
    //console.log(search.required)
    const newClassName = `${styles.locationInput}${search.required ? ` ${styles.disabled}` : ''}`
    //console.log(newClassName);
    setButtonClassName(newClassName);
  }, [search.required]);

  const handleChange = (e: string, search: ISearch) => {
    updateLocation(e)
    //console.log('Handle: ' + e)

    // Check if Valid Zip Code
    const result = checkValidZip(e)
    console.log('handlechange: ', search)
    let updatedSearch = { ...search, isValidZIP: result }
    
    console.log(updatedSearch)
    const tempDistance = distance.distance ? distance.distance : defaultAppState.distance.distance;

    if (tempDistance !== defaultAppState.distance.distance) {
      //console.log('other distance')
      updatedSearch = { required: true, isValidZIP: result}
    } else {
      updatedSearch = {required: false, isValidZIP: result }
    }
    
    updateSearch( updatedSearch );
    let currentLocation = e ? e : null;
    console.log('SearchBarLocationInput');
    const valueResult = evaluateIsDisabled(updatedSearch, currentLocation, distance.distance);
    console.log(valueResult);
  
    updateIsDisabled(valueResult);
  };

  //If ZIP Code is != '' and fails regex zip code, then below input becomes required
  /* if ( distance.distance > -1 ) {
    const result = checkValidZip(location);
    setIsRequired(true);
  } */

  return (
    <div className={styles.locationInputContainer}>
      <input className={buttonClassName} type="text" placeholder="ZIP code" value={location === 'undefined' ? '' : location} onChange={(e) => handleChange(e.target.value, search)} />
      {/* <input className={buttonClassName} type="text" placeholder="ZIP code" value={location === 'undefined' ? '' : location} required={required} onChange={(e) => handleChange(e.target.value)} /> */}
    </div>
  );
};

export default SearchBarLocationInput;
